import { Link } from "react-router-dom";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { addToWishlist } from "../action"

import axios from "../helper/axios";
import Loopingproduct from "./Common/Loopingproduct";

const toQuantityNumber = (value) => {
    if (typeof value === "number") return Number.isFinite(value) ? value : 0;
    if (typeof value === "string") {
        const parsed = Number(value.trim().replace(",", "."));
        return Number.isFinite(parsed) ? parsed : 0;
    }
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
};

// Helper function to check if all SKUs have quantity 0
const isOutOfStock = (product) => {
    if (!product?.variants || product.variants.length === 0) {
        return false; // If no variants, assume in stock
    }

    let totalSkus = 0;
    let skusWithStock = 0;

    for (const variant of product.variants) {
        if (!variant?.sizes || variant.sizes.length === 0) continue;
        
        for (const size of variant.sizes) {
            if (!size?.skus || size.skus.length === 0) continue;
            
            for (const sku of size.skus) {
                totalSkus++;
                
                // Check quantity directly or in stocks array
                const quantity = toQuantityNumber(sku?.quantity);
                const stocksQuantity = sku?.stocks?.reduce((sum, stock) => sum + toQuantityNumber(stock?.quantity), 0) ?? 0;
                const totalQuantity = quantity + stocksQuantity;
                
                if (totalQuantity > 0) {
                    skusWithStock++;
                }
            }
        }
    }

    // If there are SKUs but none have stock, product is out of stock
    return totalSkus > 0 && skusWithStock === 0;
};

const RelatedProduct = ({ catId }) => {

    let per_page = 20;
    let page = 0;
    const [productList, setProductList] = useState([]);
    const [clicking, setClicking] = useState();
    const dispatch = useDispatch();
    const wishlistItems = useSelector(state => state?.cart?.wishlistItems)

    const getProducts = async () => {
        const data = {
            catAndGender: "",
            brands: "",
            sizes: "",
            sort: "",
            id: "",
            page: page,
            per_page: per_page,
            catId: [catId]
        }
        const res = await axios.post("/related-products", data);
        // Filter out products that are out of stock
        const filteredProducts = res.data.data.filter(product => !isOutOfStock(product));
        setProductList(filteredProducts);
        
    }

    useEffect(() => {
        getProducts()
    }, [])

    const addItemToWishlist = async (res) => {
        setClicking(Math.random());
        const current = Array.isArray(wishlistItems) ? wishlistItems : [];
        const updated = [...current];
        const index = updated.findIndex(x => x?._id === res?._id);

        if (index === -1) {
            updated.push(res);
        } else {
            updated.splice(index, 1);
        }

        dispatch(addToWishlist(updated));
    }


    return (
        <div>
            <h1 className="related-prod  grid-cols-4 gap-4 flex flex-wrap mx-auto container product-list prd-head">Produkte të ngjashme</h1>

            {productList.length > 0 && (
                <div className="grid grid-cols-4 gap-4 flex flex-wrap mx-auto container product-list mb-10">
                    <Loopingproduct
                        products={productList}
                        addItemToWishlist={addItemToWishlist}
                    />
                </div>
            )}
        </div>
    )
}

export default RelatedProduct